export const hashText = async (algorithm, content) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(content);
    const h = await crypto.subtle.digest(algorithm, data);
    return Array.from(new Uint8Array(h)).map(b => b.toString(16).padStart(2, "0")).join("");
}